import { createContext } from 'react';
import { MonitoringDetailsContextType } from '@modules/monitoring/children/event-details/types/details-context';

// Контейнер для создания контекстного меню
export const MonitoringDetailsContext = createContext<MonitoringDetailsContextType | null>(null);
